import * as React from "react"
import { IRoom } from "../../../types/SiteLocation.types";
import { DefaultButton, Dialog, DialogFooter, PrimaryButton, Stack } from "office-ui-fabric-react";
import QRCode from "qrcode";

export interface IRoomQRCodeDialogProps {
    room: Partial<IRoom>;
    onDismiss: () => void;
}

const RoomQRCodeDialog = (props: IRoomQRCodeDialogProps) => {
    const { room, onDismiss } = props;
    const [ qrCode, setQrCode ] = React.useState<string>();

    React.useEffect(() => {
        const roomName = room.Name?.replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, '-');
        QRCode.toDataURL(`${window.location.protocol}//${window.location.host}/check-in/${room.SiteId}/${room.LocationId}/${room.Id}?rn=${roomName}`).then((code) => {
            setQrCode(code);
        });
    }, [room.Id, room.Name, room.LocationId, room.SiteId]);

    if (!room) return null;

    return (
        <Dialog hidden={false} dialogContentProps={{ 
            title: "QR Code",
        }} onDismiss={onDismiss}>
            <Stack horizontal verticalAlign="start" tokens={{ childrenGap: 20 }}>
                <div>
                    <img src={qrCode} alt="QR Code" />
                </div>
                <div>
                    <h2>Room QR Code</h2>
                    <p>
                        <strong>Site:</strong><br/> 
                        {room.SiteName}<br/>
                        <strong>Location:</strong><br/>
                        {room.LocationName}<br/>
                        <strong>Room:</strong><br/>
                        {room.Name}
                    </p>
                </div>
            </Stack>
            <DialogFooter>
                <Stack horizontal horizontalAlign="end" tokens={{ childrenGap: 10 }}>
                    <PrimaryButton disabled={qrCode === undefined} iconProps={{iconName: "Download"}} text="Download" onClick={() => {
                        if (qrCode) {
                            const a = document.createElement('a');
                            a.href = qrCode;
                            const name = `${room.SiteName?.replace(/\s/,'-')}_${room.LocationName?.replace(/\s/,'-')}_${room.Name?.replace(/\s/,'-')}_qr_code.png`
                            a.download = `${name || "room"}-qr-code.png`;
                            a.click();
                        }
                    }} />
                    <DefaultButton text="Close" onClick={onDismiss} />
                </Stack>
            </DialogFooter>
        </Dialog>
    );
}

export default RoomQRCodeDialog;